import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { QuestionConstant } from 'src/app/constants/label-constants';
import { QuestionImage } from 'src/app/constants/message-constant';
import { QuestionType } from 'src/app/enum/question-enum';
import { QuestionModel, multiQuestions, questionOptions, multiQuestionOptions } from 'src/app/models/questionModel';
import { EncrDecrService } from 'src/app/services/EncrDecr.service';
import { CommonService } from 'src/app/services/common/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { MatSelect } from '@angular/material/select';
interface Questions {
  id: string;
  value: string;
}
interface Questionset {
  id: string;
  value: string;
}
@Component({
  selector: 'app-question-add',
  templateUrl: './question-add.component.html',
  styleUrls: ['./question-add.component.scss']
})
export class QuestionAddComponent {
  @ViewChild('file')
  file!: ElementRef<any>;
  questionOptionArray: Array<questionOptions> = [];
  multiQuestionArray: Array<multiQuestions> = [];
  multiOptionArray: Array<questionOptions> = [];
  ParagraphSetID: number = 0;
  ParagraphObj: any;
  files!: File;
  imageURL: any;
  tempImagePath: string = '';
  atLeastParagraphOneCheckboxChecked: boolean = false;
  enum: typeof QuestionType = QuestionType;
  showImage: boolean = false;
  showParagraphText: boolean = false;
  showRadio: boolean = true;
  showMultiSelect: boolean = false;
  initalValues: any;
  saveStatus: boolean = false;
  formUnchanged = false;
  atLeastParagraphOneCorrectCheck: boolean = false;
  questionTypeList: any = [];
  questionSetList: any = [];
  questionAddForm: FormGroup = this.formBuilder.group({});
  QuestionForm: FormGroup = this.formBuilder.group({});
  QuestionId: number = 0;
  QuestionSet
  QuestionTypeId: number = 0;
  save: string = CommonConstant.SAVE;
  cancel: string = CommonConstant.CANCEL;
  optionCheckItem: FormArray<any> | undefined;
  multiQuestionCheckItem: FormArray<any> | undefined;
  multiOptionCheckItem: FormArray<any> | undefined;
  atLeastOneCheckboxChecked = false;
  SingleSelect: boolean = false;
  ParagraphWithSingleSelection: boolean = false;
  CommonConstant: any = [];
  QuestionConstant: any = [];
  protected AllQuestionlist: Questions[] = this.questionTypeList;
  protected AllQuestionsetlist: Questionset[] = this.questionSetList;
  public FilterCtrl: FormControl = new FormControl();
  public Ctrl: FormControl = new FormControl();
  public filteredData: ReplaySubject<any> = new ReplaySubject();
  public filteredquestionsetData: ReplaySubject<any> = new ReplaySubject();

  @HostListener('window:beforeunload', ['$event'])
  public canDeactivate(event: any): any {
    if (event.type == 'beforeunload') {
      if (this.CommonService.onFormValueChange(this.saveStatus, this.initalValues, this.questionAddForm.value)) {
        event.preventDefault();
        event.returnValue = false;
      }
    }
    else {
      return this.CommonService.onFormValueChange(this.saveStatus, this.initalValues, this.questionAddForm.value);
    }
  }

  ngAfterViewInit() {
  }

  @ViewChild('singleSelect', { static: true })
  singleSelect!: MatSelect;

  protected _onDestroy = new Subject();
  ngOnDestroy() {
    this._onDestroy.next(1);
    this._onDestroy.complete();
  }
  protected filterdata() {
    if (!this.questionTypeList) {
      return;
    }
    let search = this.FilterCtrl.value;
    if (!search) {
      this.filteredData.next(this.questionTypeList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredData.next(
      this.questionTypeList.filter(data => data.value.toLowerCase().indexOf(search) > -1)
    );
  }
  protected questionsetData() {
    if (!this.questionSetList) {
      return;
    }
    let search = this.Ctrl.value;
    if (!search) {
      this.filteredquestionsetData.next(this.questionSetList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredquestionsetData.next(
      this.questionSetList.filter(data => data.value.toLowerCase().indexOf(search) > -1)
    );
  }

  constructor(
    private formBuilder: FormBuilder,
    public CommonService: CommonService,
    private toster: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private apiUrl: ApiUrlHelper,
    private EncrDecr: EncrDecrService,
    private spinner: NgxSpinnerService,
    public ModalService: NgbModal,
  ) {
    this.questionAddForm = new FormGroup({
      questionText: new FormControl('', [Validators.required, Validators.maxLength(500)]),
      questionTypeId: new FormControl('', [Validators.required]),
      questionSetId: new FormControl('', [Validators.required]),
      paragraphText: new FormControl(''),
      questionImage: new FormControl(''),
      questionOptions:
        new FormArray([
          new FormGroup({
            optionText: new FormControl(null, [Validators.required, Validators.maxLength(180)]),
            isCorrectAnswer: new FormControl('', [Validators.required])
          }),
          new FormGroup({
            optionText: new FormControl(null, [Validators.required, Validators.maxLength(180)]),
            isCorrectAnswer: new FormControl('', [Validators.required])
          })
        ], this.minArrayLength(2)),
      multiQuestions:
        new FormArray([]),
    });
    this.initalValues = this.questionAddForm.value;
  }

  initMultiQuestion() {
    return new FormGroup({
      multiQuestionText: new FormControl(null, [Validators.required]),
      multiOptions: new FormArray([
        this.initMultiOptions(),
        this.initMultiOptions()
      ], this.minArrayLength(2))
    });
  }

  initMultiOptions() {
    return new FormGroup({
      multiOptionText: new FormControl(null, [Validators.required, Validators.maxLength(180)]),
      isCorrectAnswer: new FormControl('', [Validators.required])
    });
  }

  getMultiQuestions(form) {
    return form.controls.multiQuestions.controls;
  }

  getMultiOptions(form) {
    return form.controls.multiOptions.controls;
  }

  minArrayLength(minLength: number) {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const formArray = control as FormArray;
      if (formArray.length >= minLength) {
        return null;
      } else {
        return { minArrayLength: { requiredLength: minLength, actualLength: formArray.length } };
      }
    };
  }

  async ngOnInit() {
    this.filteredData.next(this.questionTypeList.slice());
    this.FilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterdata();
      });
    this.filteredquestionsetData.next(this.questionSetList.slice());
    this.Ctrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.questionsetData();
      });
    this.CommonConstant = CommonConstant;
    this.QuestionConstant = QuestionConstant;
    this.route.params.subscribe((params) => {
      if (params['id'] !== undefined) {
        var decrypted = params['id'] ? params['id'] : '';
        this.QuestionId = Number(this.EncrDecr.get('123456$#@$^@1ERF', decrypted));
      }
    })
    if (this.QuestionId > 0) {
      this.getQuestionById(this.QuestionId);
    }
    else {
      this.QuestionId = 0;
    }
    this.getQuestionTypeList();
    this.getQuestionSetList();
  }

  get questionFormControl() {
    return this.questionAddForm.controls;
  }

  get questionOptionsArray() {
    return this.questionAddForm.get('questionOptions') as FormArray;
  }

  get contacts() {
    return this.questionAddForm.controls['questionOptions'] as FormArray;
  }

  getOuterArrayControl(): FormArray {
    return this.questionAddForm.get('multiQuestions') as FormArray;
  }

  getInnerArrayControls(outerIndex: number): FormArray {
    const outerGroup = this.getOuterArrayControl().at(outerIndex) as FormGroup;
    return outerGroup.get('multiOptions') as FormArray;
  }

  optionCheck(index) {
    this.optionCheckItem = this.questionAddForm.get('questionOptions') as FormArray;
    const formGroup = this.optionCheckItem.controls[index] as FormGroup;
    return formGroup;
  }

  multiQuestionCheck(index) {
    this.multiQuestionCheckItem = this.questionAddForm.get('multiQuestions') as FormArray;
    const formGroup = this.multiQuestionCheckItem.controls[index] as FormGroup;
    return formGroup;
  }

  multiOptionCheck(i, j) {
    this.multiOptionCheckItem = this.questionAddForm.get('multiQuestions') as FormArray;
    const multiOptions = this.multiOptionCheckItem.at(i) as FormGroup
    const options = multiOptions.get('multiOptions') as FormArray
    const formGroup = options.at(j) as FormGroup
    return formGroup;
  }

  isControlTouched(control: FormControl) {
    return control.touched;
  }

  answerCheckAll() {
    var answerItem: any = [];
    this.optionCheckItem = this.questionAddForm.get('questionOptions') as FormArray;
    for (var i = 0; i < this.optionCheckItem.length; i++) {
      var ans = this.optionCheckItem.controls[i] as FormGroup;
      answerItem.push(ans.controls['isCorrectAnswer'].value);
    }
    this.SingleSelect = (this.QuestionTypeId == this.enum.SingleSelection) || (this.QuestionTypeId == this.enum.ParagraphWithSingleSelection) || (this.QuestionTypeId == this.enum.ImageWithSingleSelection);
    this.atLeastOneCheckboxChecked = this.SingleSelect ? (answerItem.filter(x => x === true).length >= 1 ? true : false) : (answerItem.filter(x => x === true).length >= 2 ? true : false);
    return this.atLeastOneCheckboxChecked;
  }

  multiQuestionanswerCheckAll(index: number) {
    var answerItem: any = [];
    this.multiOptionCheckItem = this.questionAddForm.get('multiQuestions') as FormArray;
    const multiOptions = this.multiOptionCheckItem.at(index) as FormGroup
    this.optionCheckItem = multiOptions.get('multiOptions') as FormArray
    for (var i = 0; i < this.optionCheckItem.length; i++) {
      var ans = this.optionCheckItem.controls[i] as FormGroup;
      answerItem.push(ans.controls['isCorrectAnswer'].value);
    }
    this.SingleSelect = (this.QuestionTypeId == this.enum.SingleSelection) || (this.QuestionTypeId == this.enum.ParagraphWithSingleSelection) || (this.QuestionTypeId == this.enum.ImageWithSingleSelection);
    this.atLeastParagraphOneCheckboxChecked = this.SingleSelect ? (answerItem.filter(x => x === true).length >= 1 ? true : false) : (answerItem.filter(x => x === true).length >= 2 ? true : false);
    return this.atLeastParagraphOneCheckboxChecked;
  }

  optionCheckAll() {
    var optionItem: any = [];
    this.optionCheckItem = this.questionAddForm.get('questionOptions') as FormArray;
    for (var i = 0; i < this.optionCheckItem.length; i++) {
      optionItem.push(this.optionCheckItem.controls[i].status);
    }
    return optionItem?.some(x => x === "VALID")
  }

  hasDuplicates(array: any[]): boolean {
    var flag = array.some((value, index) => array.indexOf(value) !== index)
    return flag;
  }

  optionEqualAll() {
    var optionItem: any = [];
    this.optionCheckItem = this.questionAddForm.get('questionOptions') as FormArray;
    for (var i = 0; i < this.optionCheckItem.length; i++) {
      var ans = this.optionCheckItem.controls[i] as FormGroup;
      optionItem.push(ans.controls['optionText'].value);
    }
    return this.hasDuplicates(optionItem);
  }

  optionParagraphEqualAll(i: number) {
    var optionItem: any = [];
    let multiQuestionOptionLength = this.questionAddForm.value.multiQuestions[i].multiOptions ? this.questionAddForm.value.multiQuestions[i].multiOptions.length : 0;
    for (let j = 0; j < multiQuestionOptionLength; j++) {
      optionItem.push(this.questionAddForm.value.multiQuestions[i].multiOptions[j].multiOptionText);
    }
    return this.hasDuplicates(optionItem);
  }

  getFormGroup(index: number): FormGroup {
    return this.contacts.at(index) as FormGroup;
  }

  // Get questionOptions FormArray
  get questionOptions(): FormArray {
    return this.questionAddForm.get('questionOptions') as FormArray;
  }

  // Get multiQuestions FormArray
  get multiQuestions(): FormArray {
    return this.questionAddForm.get('multiQuestions') as FormArray;
  }

  // Get multiOptions at perticular Index number
  multiOptions(i: number): FormArray {
    const multiOptions = this.multiQuestions.at(i) as FormGroup
    return multiOptions.get('multiOptions') as FormArray
  }

  // While Image Select on Image Select
  onSelectFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      if (this.CommonConstant.FILEFORMAT.includes(event.target.files[0].type)) {
        this.files = event.target.files[0];
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event) => {
          this.imageURL = reader.result;
        }
        this.tempImagePath = this.questionAddForm.controls['questionImage'].value;
      }
      else {
        this.toster.error(QuestionImage.IMAGE_INVALID);
        this.questionAddForm.get('questionImage')?.addValidators(Validators.required);
        this.file.nativeElement.value = "";
      }
    }
    else {
      this.questionAddForm.get('questionImage')?.setErrors(null);
    }
  }

  // Oncancel button click navigation
  onCancel() {
    this.router.navigate(['/question']);
  }

  getQuestionById(QuestionId: number) {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.question.GetQuestionById.replace("{id}", QuestionId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        this.spinner.hide();
        this.setQuestionForm(data.data[0]);
      },
      error: (err) => {
        this.spinner.hide();
        console.log('getQuestionById-Error', err);
      }
    });
  }

  setQuestionForm(data: QuestionModel) {
    this.QuestionForm.setValue({
      QuestionId: (data.questionId) ? data.questionId : 0,
      QuestionText: data.questionText
    });
  }

  // For questionOptions Radio button function works
  onIsPrimaryContactChecked(index: number) {
    let codeLength = this.questionAddForm.value.questionOptions ? this.questionAddForm.value.questionOptions.length : 0;
    for (let i = 0; i < codeLength; i++) {
      if (i == index) continue;
      this.getFormGroup(i).get('isCorrectAnswer')?.setValue(false);
    }
  }

  // For multiQuestions Radio button function works
  onIsMultiPrimaryContactChecked(i: number, j: number) {
    const multiQuestionsArray = this.questionAddForm.get('multiQuestions') as FormArray;
    const multiOptionsArray = multiQuestionsArray.at(i).get('multiOptions') as FormArray;
    multiOptionsArray.controls.forEach((multiOption, optionIndex) => {
      if (optionIndex === j) {
        // Skip the selected multiOption
        return;
      }
      // Reset isCorrectAnswer to false for other multiOptions
      const optionFormGroup = multiOption as FormGroup;
      optionFormGroup.patchValue({ isCorrectAnswer: false });
    });
  }

  // On Question Type Change
  onQuestionTypeChange() {
    this.ParagraphWithSingleSelection = false;
    this.QuestionTypeId = Number(this.questionAddForm.controls['questionTypeId'].value);
    let ParagraphObjIndex = this.questionSetList.findIndex(a => a.id === this.ParagraphSetID);
    if (ParagraphObjIndex >= 0) {
      this.questionSetList.splice(ParagraphObjIndex, 1);
      this.questionsetData();
    }

    switch (this.QuestionTypeId) {
      case this.enum.SingleSelection:
        this.cleareOptionsValue();
        this.showParagraphText = false;
        this.showImage = false;
        this.showRadio = true;
        this.showMultiSelect = false;
        this.removeMultiQuestionList();
        this.questionAddForm.get('questionSetId')?.enable();
        this.questionAddForm.controls['questionSetId'].setValue("");
        this.questionAddForm.get('questionImage')?.clearValidators();
        this.questionAddForm.get('questionImage')?.setErrors(null);
        this.questionAddForm.get('paragraphText')?.clearValidators();
        this.questionAddForm.get('paragraphText')?.setErrors(null);
        break;
      case this.enum.MultiSelection:
        this.cleareOptionsValue();
        this.showParagraphText = false;
        this.showImage = false;
        this.showRadio = false;
        this.showMultiSelect = true;
        this.removeMultiQuestionList();
        this.questionAddForm.get('questionSetId')?.enable();
        this.questionAddForm.controls['questionSetId'].setValue("");
        this.questionAddForm.get('questionImage')?.clearValidators();
        this.questionAddForm.get('questionImage')?.setErrors(null);
        this.questionAddForm.get('paragraphText')?.clearValidators();
        this.questionAddForm.get('paragraphText')?.setErrors(null);
        break;
      case this.enum.ImageWithSingleSelection:
        this.cleareOptionsValue();
        this.showParagraphText = false;
        this.showImage = true;
        this.showRadio = true;
        this.showMultiSelect = false;
        this.removeMultiQuestionList();
        this.questionAddForm.get('questionSetId')?.enable();
        this.questionAddForm.controls['questionSetId'].setValue("");
        this.questionAddForm.get('questionImage')?.addValidators(Validators.required);
        this.questionAddForm.get('paragraphText')?.clearValidators();
        this.questionAddForm.get('paragraphText')?.setErrors(null);
        break;
      case this.enum.ImageWithMultiSelection:
        this.cleareOptionsValue();
        this.showParagraphText = false;
        this.showImage = true;
        this.showRadio = false;
        this.showMultiSelect = true;
        this.removeMultiQuestionList();
        this.questionAddForm.get('questionSetId')?.enable();
        this.questionAddForm.controls['questionSetId'].setValue("");
        this.questionAddForm.get('questionImage')?.addValidators(Validators.required);
        this.questionAddForm.get('paragraphText')?.clearValidators();
        this.questionAddForm.get('paragraphText')?.setErrors(null);
        break;
      case this.enum.ParagraphWithSingleSelection:
        this.questionSetList.push(this.ParagraphObj);
        this.questionsetData();
        this.ParagraphWithSingleSelection = true;
        this.cleareOptionsValue();
        this.showParagraphText = true;
        this.showImage = false;
        this.showRadio = true;
        this.showMultiSelect = false;
        this.questionAddForm.get('paragraphText')?.addValidators(Validators.required);
        this.questionAddForm.get('questionImage')?.clearValidators();
        this.questionAddForm.get('questionImage')?.setErrors(null);
        for (let i = 0; i < 4; i++) {
          this.addQuestion();
        }
        this.ParagraphSetID = this.getParagraphId();
        this.questionAddForm.controls['questionSetId'].setValue(this.ParagraphSetID);
        this.questionAddForm.get('questionSetId')?.disable();
        break;
      default:
        console.log(`non-existent size: ${this.enum.SingleSelection}`);
        break;
    }
  }

  getParagraphId() {
    let paragraphIndex = this.questionSetList.findIndex(x => x.value === 'Paragraph');
    return this.questionSetList[paragraphIndex].id;
  }

  // Reset Form
  resetForm() {
    this.questionAddForm = new FormGroup({
      questionText: new FormControl('', [Validators.required, Validators.maxLength(500)]),
      questionTypeId: new FormControl('', [Validators.required]),
      questionSetId: new FormControl('', [Validators.required]),
      paragraphText: new FormControl(''),
      questionImage: new FormControl(''),
      questionOptions:
        new FormArray([
          new FormGroup({
            optionText: new FormControl(null, [Validators.required]),
            isCorrectAnswer: new FormControl('', [Validators.required])
          }),
          new FormGroup({
            optionText: new FormControl(null, [Validators.required]),
            isCorrectAnswer: new FormControl('', [Validators.required])
          })
        ], this.minArrayLength(2)),
      multiQuestions:
        new FormArray([]),
    });
  }

  // Form Submit Method 
  saveQuestion() {
    if (this.questionAddForm.valid && this.atLeastOneCheckboxChecked && !(this.checkSameOptionFunction())) {
      //True if Select Paragraph as Question Set
      if (this.ParagraphWithSingleSelection) {
        if (this.atLeastParagraphOneCorrectFunction() && !(this.checkSameQuestion())) {
          this.spinner.show();
          // Create Main Object for sending data
          const objData1 = {
            ParagraphId: 0,
            QuestionTypeId: parseInt(this.questionAddForm.controls['questionTypeId'].value),
            QuestionSetId: this.ParagraphSetID,
            ParagraphText: this.questionAddForm.controls['paragraphText'].value.toString(),
            Questions: [] as any
          }
          // Object of first Question
          let firstQuestionObj = {
            questionId: 0,
            questionStrId: "",
            questionText: this.questionAddForm.controls['questionText'].value ? this.questionAddForm.controls['questionText'].value.trim() : '',
            questionOptions: [] as multiQuestionOptions[]
          }
          //Options Object For Question object
          let optionsLength = this.questionAddForm.value.questionOptions ? this.questionAddForm.value.questionOptions.length : 0;
          for (var i = 0; i < optionsLength; i++) {
            var ans = this.questionAddForm.value.questionOptions ?
              (this.questionAddForm.value.questionOptions[i].isCorrectAnswer == undefined || String(this.questionAddForm.value.questionOptions[i].isCorrectAnswer) == '') ?
                false : Boolean(this.questionAddForm.value.questionOptions[i].isCorrectAnswer) : false
            let optionObj: multiQuestionOptions = {
              questionOptionId: 0,
              questionStrId: "",
              questionId: 0,
              optionText: this.questionAddForm.value.questionOptions[i].optionText ? this.questionAddForm.value.questionOptions[i].optionText.trim() : '',
              isCorrectOption: ans,
              isDeleted: false
            };
            // Append to first Question object
            firstQuestionObj.questionOptions.push(optionObj);
          }
          // Append First Question array to Main Object Questions
          objData1.Questions.push(firstQuestionObj)
          // for getting multiQuestions and append to main object  
          let multiQuestionLength = this.questionAddForm.value.multiQuestions ? this.questionAddForm.value.multiQuestions.length : 0;
          for (let i = 0; i < multiQuestionLength; i++) {
            let multiQuestionObj = {
              questionId: 0,
              questionStrId: "",
              questionText: this.questionAddForm.value.multiQuestions[i].multiQuestionText ? this.questionAddForm.value.multiQuestions[i].multiQuestionText : '',
              questionOptions: [] as multiQuestionOptions[]
            }
            let multiQuestionOptionLength = this.questionAddForm.value.multiQuestions[i].multiOptions ? this.questionAddForm.value.multiQuestions[i].multiOptions.length : 0;
            for (let j = 0; j < multiQuestionOptionLength; j++) {
              var ans = this.questionAddForm.value.multiQuestions[i].multiOptions ?
                (this.questionAddForm.value.multiQuestions[i].multiOptions[j].isCorrectAnswer == undefined || String(this.questionAddForm.value.multiQuestions[i].multiOptions[j].isCorrectAnswer) == '') ?
                  false : Boolean(this.questionAddForm.value.multiQuestions[i].multiOptions[j].isCorrectAnswer) : false
              let optionObj: multiQuestionOptions = {
                questionOptionId: 0,
                questionStrId: "",
                questionId: 0,
                optionText: this.questionAddForm.value.multiQuestions[i].multiOptions[j].multiOptionText ? this.questionAddForm.value.multiQuestions[i].multiOptions[j].multiOptionText.trim() : '',
                isCorrectOption: ans,
                isDeleted: false
              };
              multiQuestionObj.questionOptions.push(optionObj);
            }
            objData1.Questions.push(multiQuestionObj)
          }
          this.saveStatus = true;
          // Calling SaveMultiple Question API call
          const apiUrl = this.apiUrl.apiUrl.question.SaveMultiple;
          this.CommonService.doPost(apiUrl, objData1).pipe().subscribe({
            next: async (data) => {
              if (data.success) {
                this.spinner.hide();
                this.questionAddForm.reset();
                this.router.navigate(['question'])
                this.toster.success(data.message);
              }
              else {
                this.spinner.hide();
                this.toster.error(data.message);
              }
            },
            error: (error) => {
              this.spinner.hide();
              this.CommonService.checkAuthorize(error);
            }
          });
        }
      }

      //True if user not select paragraph as Question Set
      else {
        let optionRequest = {};
        this.questionOptionArray = [];
        let optionsLength = this.questionAddForm.value.questionOptions ? this.questionAddForm.value.questionOptions.length : 0;
        for (var i = 0; i < optionsLength; i++) {
          if (this.questionAddForm.status) {
            var ans = this.questionAddForm.value.questionOptions ?
              (this.questionAddForm.value.questionOptions[i].isCorrectAnswer == undefined || String(this.questionAddForm.value.questionOptions[i].isCorrectAnswer) == '') ?
                false : Boolean(this.questionAddForm.value.questionOptions[i].isCorrectAnswer) : false
            let optionObj: questionOptions = {
              questionOptionId: 0,
              optionText: this.questionAddForm.value.questionOptions ? this.questionAddForm.value.questionOptions[i].optionText.trim() : '',
              isCorrectOption: ans,
              isDeleted: false
            };
            this.questionOptionArray.push(optionObj);
            optionRequest = {
              insertUpdateOptionRequestModel: this.questionOptionArray
            }
          }
        }
        if (this.questionAddForm.valid && this.atLeastOneCheckboxChecked) {
          this.saveStatus = true;
          this.spinner.show();
          let formData = new FormData()
          formData.append('file', this.files);
          formData.append('QuestionText', this.questionAddForm.controls['questionText'].value ? this.questionAddForm.controls['questionText'].value.trim() : '');
          formData.append('ParagraphText', this.questionAddForm.controls['paragraphText'].value ? this.questionAddForm.controls['paragraphText'].value.trim() : '');
          formData.append('QuestionTypeId', this.questionAddForm.controls['questionTypeId'].value ? this.questionAddForm.controls['questionTypeId'].value : '');
          formData.append('QuestionSetId', this.questionAddForm.controls['questionSetId'].value ? this.questionAddForm.controls['questionSetId'].value : '');
          formData.append('QuestionOptiontJsonString', JSON.stringify(optionRequest['insertUpdateOptionRequestModel']));
          const apiUrl = this.apiUrl.apiUrl.question.SaveQuestion;
          this.CommonService.doPost(apiUrl, formData).pipe().subscribe({
            next: async (data) => {
              if (data.success) {
                this.questionAddForm.reset();
                this.spinner.hide();
                this.router.navigate(['question'])
                this.toster.success(data.message);
              }
              else {
                this.spinner.hide();
                this.toster.error(data.message);
              }
            },
            error: (error) => {
              this.spinner.hide();
              this.CommonService.checkAuthorize(error);
            }
          });
        }
        else {
          this.questionAddForm.markAllAsTouched();
        }
      }
    }
  }
  // Clear Values of Options 
  //Called While change in QuestionSet Change
  cleareOptionsValue() {
    let singleOptionLength = this.questionAddForm.value.questionOptions ? this.questionAddForm.value.questionOptions.length : 0;
    for (let i = 0; i < singleOptionLength; i++) {
      this.getFormGroup(i).get('isCorrectAnswer')?.setValue(false);
    }
  }

  //Get Question Set List From Database
  getQuestionSetList() {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.test.GetQuestionSetListWithOutCount;
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data && data.data && data.data.length > 0) {

          for (let i = 0; i < data.data.length; i++) {
            if (data.data[i].questionSetName != 'Paragraph') {
              this.questionSetList.push({ 'id': data.data[i].questionSetId, 'value': data.data[i].questionSetName })
            }
            else {
              this.ParagraphObj = {
                'id': data.data[i].questionSetId, 'value': data.data[i].questionSetName
              }
            }
          }
          this.AllQuestionsetlist = this.questionSetList;
          this.questionsetData();
          this.spinner.hide();
        }
      },
      error: (err) => {
        console.log('getHandlerList-Error', err);
      }
    });
  }

  //Getting Question type list from Database
  getQuestionTypeList() {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.question.GetQuestionTypes;
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data && data.data && data.data.length > 0) {
          for (let i = 0; i < data.data.length; i++) {
            this.questionTypeList.push({ 'id': data.data[i].questionTypeId, 'value': data.data[i].questionTypeText })
          }
          this.filterdata();
          this.spinner.hide();
        }
      },
      error: (err) => {
        console.log('getHandlerList-Error', err);
      }
    });
  }

  //adding option
  addOption(i: number) {
    this.questionOptions.push(
      new FormGroup({
        optionText: new FormControl('', [Validators.required]),
        isCorrectAnswer: new FormControl(false, [Validators.required])
      })
    );
  }

  // Add Question for Paragraph Text
  addQuestion() {
    const control = <FormArray>this.questionAddForm.get('multiQuestions');
    control.push(this.initMultiQuestion());
  }

  //Add Option to multiQuestions FormArray on specific index
  addOptions(i) {
    this.multiQuestionCheckItem = this.questionAddForm.get('multiQuestions') as FormArray;
    const control = <FormArray>this.multiQuestionCheckItem.controls[i].get('multiOptions');
    control.push(this.initMultiOptions());
  }

  //removing option from main FormArray questionOptions
  removeOption(i: number) {
    const control = <FormArray>this.questionAddForm.controls['questionOptions'];
    let codeLength = this.questionAddForm.value.questionOptions ? this.questionAddForm.value.questionOptions.length : 0;
    if (codeLength > 1) {
      control.removeAt(i - 1);
    }
    else {
      this.questionAddForm.reset();
    }
  }

  //removing option from multiQuestions FromArray on specific number of array
  multiQuestionremoveOption(i: number, j: number) {
    const control = <FormArray>this.multiOptions(i);
    let codeLength = control ? control.length : 0;
    if (codeLength > 1) {
      control.removeAt(j);
    }
    else {
      this.questionAddForm.reset();
    }
  }

  //Clear multiQuestions FormArray to empty
  removeMultiQuestionList() {
    const control = <FormArray>this.questionAddForm.controls['multiQuestions'];
    let codeLength: number = this.questionAddForm.value.multiQuestions ? this.questionAddForm.value.multiQuestions.length : 0;
    if (codeLength > 0) {
      control.clear();
    }
  }

  CheckCorrect(i: number) {
    return this.getFormGroup(i).get('isCorrectAnswer')?.value;
  }

  CheckParagraphCorrect(i: number, j: number) {
    return this.multiOptionCheck(i, j).get('isCorrectAnswer')?.value;
  }

  atLeastParagraphOneCorrectFunction() {
    let currentQuestion: boolean = false;
    let multiQuestionLength = this.questionAddForm.value.multiQuestions ? this.questionAddForm.value.multiQuestions.length : 0;
    for (let i = 0; i < multiQuestionLength; i++) {
      currentQuestion = false;
      let multiQuestionOptionLength = this.questionAddForm.value.multiQuestions[i].multiOptions ? this.questionAddForm.value.multiQuestions[i].multiOptions.length : 0;
      for (let j = 0; j < multiQuestionOptionLength; j++) {
        if (this.questionAddForm.value.multiQuestions[i].multiOptions[j].isCorrectAnswer == true) {
          currentQuestion = true
        }
      }
      if (currentQuestion) {
        this.atLeastParagraphOneCheckboxChecked = true;
      }
      else {
        this.atLeastParagraphOneCheckboxChecked = false;
      }
    }
    return this.atLeastParagraphOneCheckboxChecked;
  }

  checkSameOptionFunction() {
    var optionItem: any = [];
    var flag: boolean = false;
    this.optionCheckItem = this.questionAddForm.get('questionOptions') as FormArray;
    for (var i = 0; i < this.optionCheckItem.length; i++) {
      var ans = this.optionCheckItem.controls[i] as FormGroup;
      optionItem.push(ans.controls['optionText'].value);
    }
    if (this.hasDuplicates(optionItem)) {
      flag = true;
    }
    let multiQuestionLength = this.questionAddForm.value.multiQuestions ? this.questionAddForm.value.multiQuestions.length : 0;
    for (let i = 0; i < multiQuestionLength; i++) {
      optionItem = [];
      let multiQuestionOptionLength = this.questionAddForm.value.multiQuestions[i].multiOptions ? this.questionAddForm.value.multiQuestions[i].multiOptions.length : 0;
      for (let j = 0; j < multiQuestionOptionLength; j++) {
        optionItem.push(this.questionAddForm.value.multiQuestions[i].multiOptions[j].multiOptionText);
      }
      if (this.hasDuplicates(optionItem)) {
        flag = true;
      }
    }
    return flag;
  }

  checkSameQuestion() {
    var QuestionItem: any = [];
    var flag: boolean = false;
    QuestionItem.push(this.questionAddForm.controls['questionText'].value ? this.questionAddForm.controls['questionText'].value.trim() : '');
    let multiQuestionLength = this.questionAddForm.value.multiQuestions ? this.questionAddForm.value.multiQuestions.length : 0;
    for (let i = 0; i < multiQuestionLength; i++) {
      QuestionItem.push(this.questionAddForm.value.multiQuestions[i].multiQuestionText ? this.questionAddForm.value.multiQuestions[i].multiQuestionText.trim() : '');
    }
    return this.hasDuplicates(QuestionItem)
  }
}
